export { default as TestFaolIshtrokchilar } from "./faol-ishtrokchilar";
export { default as TestFikrlar } from "./fikrlar";
export { default as TestModal } from "./test-modal";
export { default as TopicTestLayout } from "./topic-test-layout";
